import { PageHeader } from "@/components/PageHeader";
import { ModelSettingsSection } from "@/components/ModelSettingsSection";

// Settings hosts user-tunable knobs. The Models section pins logical
// tiers (deep/standard/cheap) to concrete catalog models per SPEC §8.
export default function Settings() {
  return (
    <>
      <PageHeader
        title="Settings"
        description="Knobs that affect bee's behaviour."
      />
      <div className="mt-4">
        <ModelSettingsSection />
      </div>
    </>
  );
}
